import { UPDATE_CAMERA } from '../actions/action-types';

const initialState = {
  position: { x: 0, y: 0, z: 500 },
  quaternion: { _x: 0, _y: 0, _z: 0, _w: 1 },
};

function camera(state = initialState, action){
  switch(action.type){
    case UPDATE_CAMERA:
      return {
        ...state,
        position: action.position,
        quaternion: action.quaternion,
      };
    default:
      return state;
  }
}

export default camera;



// WEBPACK FOOTER //
// ./src/reducers/camera.js